<template>
  <Label text="New" icon-name="newIcon" :color="LabelColors.Purple" :size="LabelSizes.Small" />
</template>

<script setup lang="ts">
import Label from '../../common/label/Label.vue'
import { LabelColors, LabelSizes } from '@/components/common/label/utils'

defineEmits(['close-action', 'icon-action'])
</script>

<style lang="scss" scoped></style>
